export const mobileWidth = 1021;

export const customMobileWidth= 567;

export const customMobileView= `@media (max-width: 567px)`;

export const mobileView = `@media (max-width: 1021px)`;